<template>
  <label class="ui-switch" :class="{ 'is-disabled': disabled }">
    <input
      class="ui-switch__input"
      type="checkbox"
      role="switch"
      :checked="modelValue"
      :disabled="disabled"
      @change="onChange"
    />

    <span class="ui-switch__track" aria-hidden="true"><span class="ui-switch__knob" /></span>

    <span v-if="$slots.default" class="ui-switch__label"><slot /></span>
  </label>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue?: boolean;
    disabled?: boolean;
  }>(),
  {
    modelValue: false,
    disabled: false,
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
}>();

const onChange = (event: Event): void => {
  emit("update:modelValue", (event.target as HTMLInputElement).checked);
};
</script>
